import * as React from 'react'

/** Displays an offer type. */
const OfferTypeItem: React.FC = ({ children }) => <span className="monospace-text">{children}</span>

export default OfferTypeItem
